import LoginCard from 'containers/LoginPage/LoginCard/LoginCard';
import moment from 'moment';
import { PureComponent, ReactNode } from 'react';
import { MapDispatchToProps, MapStateToProps, connect } from 'react-redux';
import { openCloseLoginModal } from 'store/loginModal/LoginModalSlice';
import { RootState } from 'store/store';
import { LoginModalBackdrop, LoginModalDialog } from './LoginModal-style';
import {
  ILoginModalDispatchToProps,
  ILoginModalOwnProps,
  ILoginModalProps,
  ILoginModalState,
  ILoginModalStateToProps,
} from './LoginModal-type';
import { appDispatch } from 'store/store';

class LoginModalComponent extends PureComponent<
  ILoginModalProps,
  ILoginModalState
> {
  public constructor(props: ILoginModalProps) {
    super(props);
    this.state = {};
  }

  private getTimeDifference(): { diffMinute: number; diffDay: number } {
    const { thisUser } = this.props;
    const expireDate = thisUser.expireDate!;

    const currentDateTime = moment();
    const expireDateTime = moment.unix(expireDate / 1000);
    const diffMinute: number = expireDateTime.diff(currentDateTime, 'minute');
    const diffDay: number = expireDateTime.diff(currentDateTime, 'day');

    return { diffMinute, diffDay };
  }

  private intervalBody(): void {
    const { diffMinute } = this.getTimeDifference();

    if (diffMinute <= 2) {
      /*test*/
      this.props.openCloseLoginModal();
      this.cancelInterval();
    }
  }

  private startInterval(): void {
    const { thisUser } = this.props;
    const { interval } = this.state;

    const isLoggedIn: boolean = thisUser.isLoggedIn;

    const { diffDay } = this.getTimeDifference();

    if (isLoggedIn && !interval && diffDay < 14) {
      const newInterval = setInterval((): void => {
        this.intervalBody();
      }, 10000);

      this.setState({
        interval: newInterval,
      });
    }
  }

  private cancelInterval(): void {
    const { interval } = this.state;

    if (interval) {
      clearInterval(interval);
      this.setState({ interval: undefined });
    }
  }

  public componentDidMount(): void {
    this.startInterval();
  }

  public componentDidUpdate(): void {
    this.startInterval();
  }

  public render(): ReactNode {
    const { isOpen } = this.props;
    if (isOpen) {
      return (
        <>
          <LoginModalDialog open>
            <LoginCard usageType="loginModal" />
          </LoginModalDialog>
          <LoginModalBackdrop />
        </>
      );
    }

    return null;
  }
}

const mapStateToProps: MapStateToProps<
  ILoginModalStateToProps,
  ILoginModalOwnProps,
  RootState
> = (state) => {
  const isOpen: boolean = state.loginModal.isOpen;

  const thisUser = state.thisUser;

  return { isOpen, thisUser };
};

const mapDispatchToProps: MapDispatchToProps<
  ILoginModalDispatchToProps,
  ILoginModalOwnProps
> = () => {
  return {
    openCloseLoginModal: (isOpen?: boolean) =>
      appDispatch(openCloseLoginModal(isOpen)),
  };
};

export const LoginModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginModalComponent);
